import EventMarketUpdateMapper from './event-market-update-mapper';
import LiveModel from '../../agent/live/live-model';
import MarketModel from '../../agent/market/market-model';

const EventMarketUpdateModel = {
    mapper: EventMarketUpdateMapper,

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    eventId: {
        fieldName: 'e',
        type: String,
    },

    eventMbn: {
        fieldName: 'b',
        type: Number,
    },

    leagueId: {
        fieldName: 'g',
        type: String,
    },

    live: {
        fieldName: 'l',
        type: Boolean,
    },

    liveStatistics: {
        fieldName: 'a',
        model: LiveModel,
        type: Object,
    },

    marketCount: {
        fieldName: 'k',
        type: Number,
    },

    markets: {
        fieldName: 'm',
        model: MarketModel,
        modelContext: {
            eventId: 'eventId',
        },
        type: Array,
    },

    scheduleDate: {
        fieldName: 'd',
        type: Number,
    },

    sportId: {
        fieldName: 's',
        type: String,
    },

    type: {
        fieldName: 't',
        type: String,
    },

    outright: {
        fieldName: 'o',
        type: Boolean,
    },
};

export default EventMarketUpdateModel;
